import { render, staticRenderFns } from "./realname.vue?vue&type=template&id=59be8302&scoped=true&"
import script from "./realname.vue?vue&type=script&lang=js&"
export * from "./realname.vue?vue&type=script&lang=js&"
import style0 from "./realname.vue?vue&type=style&index=0&id=59be8302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be8302",
  null
  
)

export default component.exports